import React from 'react'

import FavoritesLayout from 'presentation/secretary/layouts/Favorites'

export const SecretaryFavorites = () => {
  return <FavoritesLayout />
}
